import type { FeedbackStatus } from "../../../api";
import { Button } from "../../ui";

type FeedbackResolutionActionsProps = {
  status: FeedbackStatus;
  saving: boolean;
  onStatusChange: (status: FeedbackStatus) => void;
};

export function FeedbackResolutionActions({
  status,
  saving,
  onStatusChange,
}: FeedbackResolutionActionsProps) {
  const isResolved = status === "resolved";

  return (
    <div className="flex justify-end gap-2">
      <Button
        type="button"
        variant={isResolved ? "secondary" : "primary"}
        onClick={() => onStatusChange(isResolved ? "open" : "resolved")}
        disabled={saving}
      >
        {saving ? "Saving..." : isResolved ? "Reopen" : "Mark resolved"}
      </Button>
    </div>
  );
}
